module.exports = __webpack_public_path__ + "img/bj-strawberry.09bfa5da.gif";